import {EngagementsList} from "./components/engagements-list/components/engagement-basic-list/EngagementsList.tsx";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";


const EngagementsPage = () => {
    useDocumentTitle("Engagements");

    return (
        <div className="p-3">

            <EngagementsList/>

        </div>
    );
};


export default (EngagementsPage);
